
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import horvat from "../../assets/horvat.jpg";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function HorvatMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Horvát magyar fordító</title>
                <meta name='description' content="Ingyenes horvát magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Horvát magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/horvat-magyar-fordito" />
            </Helmet>
            <h1>Horvát magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A horvát nyelvről</h2>
                    <img src={horvat} alt="Horvát zászló"></img>
                </div>

                <p>A horvát egy délszláv nyelv, amelyet elsősorban Horvátországban beszélnek, ahol ez a hivatalos nyelv. A szomszédos országokban kisebbségi nyelvként is elismert, és világszerte vannak beszélői a horvát diaszpóra közösségekben.</p>

                <p>A horvát nyelv az indoeurópai nyelvcsaládba tartozik, és hasonlóságokat mutat más szláv nyelvekkel, például a szerb, a bosnyák és a szlovén nyelvekkel. A horvát nyelvnek azonban megvannak a maga sajátos jellemzői és szókincse.</p>

                <p>A latin ábécét használja, néhány további diakritikus jellel kiegészítve. 30 betűből áll, beleértve a č, ž, š, š, đ és lj különleges karaktereket is. A horvát kiejtés általában fonetikus, a betűhangokra egységes szabályok vonatkoznak.</p>

                <p>Nyelvtana a főnevek, melléknevek és névmások deklinációjának mérsékelten összetett rendszerét tartalmazza. A nyelvtani kapcsolatok jelölésére hét eset van, mint például a nominativus, akkuzatív, genitivus, dativus, instrumentális, lokatívus és vokatívus. Az igék ragozása idő, mód, aspektus és személy szerint történik.</p>

                <p>Szókincsét különböző források befolyásolták. Közös gyökerei vannak más szláv nyelvekkel, és vannak kölcsönszavak a német, olasz, magyar és török nyelvekből. Emellett vannak regionálisan specifikus szavak és kifejezések, amelyek a helyi dialektusokat és kulturális árnyalatokat tükrözik.</p>

                <p>A horvát nyelv gazdag irodalmi hagyományokkal rendelkezik, olyan neves szerzőkkel, mint Miroslav Krleža és Ivan Gundulić, akik hozzájárultak a gazdag irodalomhoz. A nyelvet a költészet, a zene, a színház és a film is ünnepli Horvátországban.</p>

                <p>A nyelv tanulása hozzáférést biztosíthat a horvát kultúrához, történelemhez és társadalomhoz. Lehetővé teszi a horvát irodalommal és médiával való foglalkozást, és elősegíti az ország örökségének és kortárs kérdéseinek mélyebb megértését.</p>

                <p>Hasznos azok számára, akik Horvátországban szeretnének utazni, tanulni vagy dolgozni, mivel megkönnyíti a kommunikációt és a kulturális integrációt. Emellett értékes készség a kutatók, fordítók és a balkáni régiót érintő nemzetközi kapcsolatokkal foglalkozó szakemberek számára is.</p>

                <div className="sectionbottom">
                    <Link to="/magyar-horvat-fordito">Magyar horvát fordító</Link>

                    <img src={horvat} alt="horvát zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>

            </section>
        </>

    )
}

export default HorvatMagyar;